<template>
  <div class="signIn">
    <amplify-authenticator username-alias="email">
      <amplify-sign-in
        slot="sign-in"
        :hide-sign-up="true"
        username-alias="email"
      >
      </amplify-sign-in>
    </amplify-authenticator>
  </div>
</template>

<script>
import "@aws-amplify/ui-vue";
import { Auth, Hub } from "aws-amplify";
export default {
  data() {
    return {
      authConfig: {
        signInConfig: {
          isSignUpDisplayed: false,
        },
      },
      username: "",
      message: {
        showError: false,
        errorMessage: null,
        show: false,
        message: null,
      },
    };
  },
  created() {
    Hub.listen("auth", async (state) => {
      if (state.payload.event === "signIn") {
        this.findUser();
        this.$store.state.signedIn = true;
        this.$router.push({ path: "/" });
      } else {
        this.$store.state.signedIn = false;
      }
    });
    // AmplifyEventBus.$on("authState", info => {
    //   if (info === "signedIn") {
    //     this.findUser();
    //     this.$store.state.signedIn = true;
    //     this.$router.push({ path: "/" });
    //   } else {
    //     this.$store.state.signedIn = false;
    //   }
    // });
    this.findUser();
  },
  methods: {
    async findUser() {
      await Auth.currentAuthenticatedUser()
        .then((data) => {
          this.$cookie.set(
            "AWSTOKEN",
            data.signInUserSession.accessToken.jwtToken,
            { expires: "1Y", domain: "hpapps.healthyperformance.co.uk" }
          );
          this.$store.state.signedIn = true;
          this.$store.state.user = data;
        })
        .catch((err) => {
          this.$store.state.signedIn = false;
        });
    },
  },
  computed: {
    signedIn() {
      return this.$store.state.signedIn;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
